import React from 'react'
import { Typography } from '@mui/material'
import { PatientFormDisclaimerProps } from './_props'
import useStyles from './_styles/PatientFormDisclaimerStyles'
import { AnnouncementIcon } from '../../../assets/icons/icons'
import { generateRandomGuiID } from '../../../utils/commonUtils'

const PatientFormDisclaimer = ({ title, textContents, displayed }: PatientFormDisclaimerProps) => {
    const classes = useStyles()

    if (!displayed) return null

    return (
        <div className={classes.PatientFormDisclaimer}>
            <div className={classes.PatientFormDisclaimerLeft}>
                <AnnouncementIcon className={classes.PatientFormDisclaimerIcon} />
            </div>
            <div className={classes.PatientFormDisclaimerRight}>
                <Typography className={classes.PatientFormDisclaimerTitle}>
                    {title || 'Informations manquantes'}
                </Typography>
                <div className={classes.PatientFormDisclaimerContents}>
                    {textContents.map((textContent) => {
                        const key = generateRandomGuiID()
                        return (
                            <Typography key={key} className={classes.PatientFormDisclaimerContent}>
                                {textContent}
                            </Typography>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

export default PatientFormDisclaimer
